import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry
*/
import React from 'react';
import SvgIcon from 'wfui-digital-core/es/SvgIcon';
import accessibleIcon from 'wfui-digital-core/es/accessibleIcon';
import useBrand from 'wfui-digital-core/es/useBrand';
import { getIconClasses } from 'wfui-digital-core/es/lib';
import styles from './ProfileMenuIcon.less';

var MassMarketIcon = function MassMarketIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '30px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '30px' : _ref$height,
      props = _objectWithoutProperties(_ref, ["width", "height"]);

  var _map = [height, width].map(function (v) {
    return v.slice(0, -2);
  }),
      _map2 = _slicedToArray(_map, 2),
      svgHeight = _map2[0],
      svgWidth = _map2[1];

  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: width,
    height: height,
    viewBox: "0 0 ".concat(svgHeight, " ").concat(svgWidth)
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: "15",
    cy: "15",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 29C7.268 29 1 22.732 1 15S7.268 1 15 1s14 6.268 14 14-6.268 14-14 14zm0-16a3 3 0 110-6 3 3 0 010 6zm0 2a5 5 0 100-10 5 5 0 000 10zm-2.985 2.873c1.25-.103 2.022-.02 2.985 0 1.253.026 1.442 0 3.003 0 1.296.075 2.643.864 3.428 2.362.551 1.052.624 2.727.93 3.98.445-.37.767-.653.966-.849.189-.186.448-.476.778-.87-.204-1.566-.422-2.467-.98-3.374-.902-1.463-1.858-2.018-2.46-2.432-.602-.413-2.063-.813-2.662-.813-2.32 0-5.021-.259-7.003.123-2.444.471-5.147 3.16-5.147 6.496.374.418.659.724.855.917.192.19.496.457.912.803.241-1.898.413-3.246 1.02-4.18.922-1.416 2.124-2.06 3.375-2.163z",
    fill: "#D71E28"
  })));
};

var ThePrivateBankIcon = function ThePrivateBankIcon(_ref2) {
  var _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '30px' : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '30px' : _ref2$height,
      props = _objectWithoutProperties(_ref2, ["width", "height"]);

  var _map3 = [height, width].map(function (v) {
    return v.slice(0, -2);
  }),
      _map4 = _slicedToArray(_map3, 2),
      svgHeight = _map4[0],
      svgWidth = _map4[1];

  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: width,
    height: height,
    viewBox: "0 0 ".concat(svgHeight, " ").concat(svgWidth)
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "13.866",
    cy: "13.866",
    r: "13.866"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: "13.866",
    cy: "13.866",
    r: "11.786"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.121 1.154)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    cx: "13.866",
    cy: "13.866",
    r: "14.366"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.257 8.396c0 2.464-1.936 4.46-4.328 4.46-2.391 0-4.329-1.996-4.329-4.46 0-2.462 1.938-4.46 4.329-4.46 2.392 0 4.328 1.998 4.328 4.46zM22.46 24.32c.224 2.8-1.823 5.09-4.55 5.09H9.816c-2.726 0-4.773-2.29-4.549-5.09l.59-3.523c.224-2.8 2.637-5.09 5.364-5.09h5.286c2.726 0 5.14 2.29 5.365 5.09l.589 3.523z",
    stroke: "#FFF",
    strokeWidth: "2",
    mask: "url(#c)"
  })));
};

var ProfileMenuIcon = function ProfileMenuIcon(_ref3) {
  var className = _ref3.className,
      keepProps = _objectWithoutProperties(_ref3, ["className"]);

  var brand = useBrand();
  var classNames = getIconClasses({
    styles: styles,
    classes: ['profileMenu'],
    className: className
  });
  return 'tpb' === brand ? /*#__PURE__*/React.createElement(ThePrivateBankIcon, _extends({}, keepProps, {
    className: classNames
  })) : /*#__PURE__*/React.createElement(MassMarketIcon, _extends({}, keepProps, {
    className: classNames
  }));
};

export default /*#__PURE__*/React.memo(accessibleIcon(ProfileMenuIcon));